import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LinkIcon from "@mui/icons-material/Link";
import { cleanText } from "./utils/doctorDisplay";
export function DoctorContactSection({ display, }) {
    const phoneNumber = cleanText(display.phoneNumber);
    const email = cleanText(display.email);
    const websiteUrl = cleanText(display.websiteUrl);
    if (!phoneNumber && !email && !websiteUrl)
        return null;
    return (_jsxs(Stack, { spacing: 1, children: [phoneNumber && (_jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, children: [_jsx(PhoneIcon, { sx: { fontSize: 18, color: "primary.main", flexShrink: 0 } }), _jsx(Typography, { variant: "body2", component: "a", href: `tel:${phoneNumber.replace(/\s/g, "")}`, color: "text.secondary", sx: {
                            textDecoration: "none",
                            "&:hover": {
                                color: "primary.main",
                                textDecoration: "underline",
                            },
                        }, children: phoneNumber })] })), email && (_jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, children: [_jsx(EmailOutlinedIcon, { sx: { fontSize: 18, color: "primary.main", flexShrink: 0 } }), _jsx(Typography, { variant: "body2", component: "a", href: `mailto:${email}`, color: "text.secondary", sx: {
                            textDecoration: "none",
                            wordBreak: "break-word",
                            "&:hover": {
                                color: "primary.main",
                                textDecoration: "underline",
                            },
                        }, children: email })] })), websiteUrl && (_jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, children: [_jsx(LinkIcon, { sx: { fontSize: 18, color: "primary.main", flexShrink: 0 } }), _jsx(Link, { href: websiteUrl, target: "_blank", rel: "noopener noreferrer", variant: "body2", underline: "hover", sx: { color: "text.secondary", wordBreak: "break-word" }, children: websiteUrl })] }))] }));
}
